<template>
  <div>
    <el-form
      class="mt-2"
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      label-width="130px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_tskOverview') || '任务概要'"
          prop="tskOverview"
        >
          <el-input
            v-model="formData.tskOverview"
            :placeholder="$l('form_placeholder_tskOverview')"
            type="text"
            :maxlength="200"
            show-word-limit
            clearable
            @change="valueChange"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_tskBy') || '经办人'" prop="tskBy">
          <dict-select
            v-model="formData.tskBy"
            :selectedLabel.sync="formData.tskByName"
            @change="valueChange"
            url="/master/common/dict/baseUserSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item :label="$l('form_label_tskInfoNo') || '任务编号'">
          <el-input
            v-model="formData.tskInfoNo"
            :placeholder="$l('form_placeholder_tskInfoNo')"
            readonly
            style="width: 100%"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_custName') || '客户'"
          prop="custCode"
        >
          <dict-select
            v-model="formData.custCode"
            url="/master/common/dict/customerSelectByStatus"
            :body="{ dictType: ['W', 'P', 'B', 'Y'] }"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
            size="mini"
            style="width: 100%"
            @change="custChange"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_expoInfoCode') || '展会信息'"
          prop="expoInfoCode"
        >
          <dict-select
            ref="expoInfoSelect"
            v-model="formData.expoInfoCode"
            @change="changeExpoInfo"
            url="/digitalCenter/expo/info/tsk/dictSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_expoMeetingCode') || '会议信息'"
          prop="expoMeetingCode"
        >
          <dict-select
            ref="expoInfoSelect"
            v-model="formData.expoMeetingCode"
            :body="{
              expoInfoCode: formData.expoInfoCode,
              custCode: formData.custCode,
            }"
            @change="changeExpoMeeting"
            :disabled="!formData.custCode"
            url="/digitalCenter/expo/meeting/tsk/dictSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_tskTimeZone') || 'Time zone'"
          prop="tskTimeZone"
        >
          <el-row :gutter="5">
            <el-col :span="12">
              <el-select
                v-model="formData.tskTimeZone"
                collapse-tags
                size="mini"
                style="width: 100%"
                :placeholder="
                  $l('form_placeholder_meetingTimeZone') || '请选择时区'
                "
                clearable
                filterable
                @change="valueChange"
              >
                <el-option
                  v-for="item in tskTimeZoneOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="brand-select"
                >
                  <span>{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="formData.tskEndDate"
                @change="valueChange"
                type="date"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
                style="max-width: 100%"
                :placeholder="$l('form_placeholder_tskEndDate')"
              />
            </el-col>
            <el-col :span="6">
              <el-time-picker
                v-model="formData.tskEndTime"
                format="HH:mm"
                value-format="HH:mm"
                :placeholder="$l('form_placeholder_tskEndTime')"
                style="max-width: 100%"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div class="el-form-row" v-if="taskLocalTime">
        <el-form-item :label="$l('form_label_localTime') || 'Local Time'">
          <el-input :value="taskLocalTime" readonly />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_tskImportantLevel') || 'Important Level'"
        >
          <ImportantLevelRadio v-model="formData.tskImportantLevel" />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_tskStatus') || '状态'"
          class="tag-ifno"
        >
          <div style="display: flex; align-items: center">
            <el-tag size="mini" effect="dark" type="info">
              {{ $l('form_label_todo') || '待办' }}</el-tag
            >
          </div>
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_tskDescription') || 'Task topics'"
          prop="tskDescription"
        >
          <TopicsEditor
            v-model="formData.tskDescription"
            @change="valueChange"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <div class="el-form-item el-form-item--mini" style="height: 210px">
          <div class="el-form-item__label" style="width: 130px">
            {{ $l('tips_task_doc') || '任务附件' }}
            <div class="mt-2">
              <el-button
                class="button_info fws"
                type="primary"
                size="mini"
                @click.stop="uploadTskFile"
              >
                <span>
                  {{ $l('btn_uploadTaskDoc') || '上传任务附件' }}
                </span>
              </el-button>
            </div>
            <div class="mt-2">
              <el-button
                class="fws"
                type="primary"
                size="mini"
                :disabled="!formData.expoMeetingCode"
                @click.stop="chooseMeetingDoc()"
              >
                <span>
                  {{ $l('btn_chooseMeetingDoc') || '选择会议文档' }}
                </span>
              </el-button>
            </div>
          </div>
          <div
            class="el-form-item__content"
            style="padding: 10px; margin-left: 130px"
          >
            <TaskDoc
              ref="taskDoc"
              :key="'taskDoc'"
              :tskInfoCode="tskInfoCode"
              :expoMeetingCode="formData.expoMeetingCode"
              :customStyle="`height:190px;overflow: auto;`"
            />
          </div>
        </div>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_task_createBy') || '报告人'">
          <el-input
            v-model="formData.createByName"
            :placeholder="$l('form_placeholder_task_createBy')"
            readonly
          />
        </el-form-item>
        <el-form-item :label="$l('form_label_reportTime') || '报告时间'">
          <el-input
            v-model="formData.createDate"
            :placeholder="$l('form_placeholder_reportTime')"
            readonly
          />
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      v-if="chooseMeetingVisible"
      visible
      :title="$l('dialog_title_choose_meeting_doc') || '选择会议文件'"
      direction="rtl"
      width="800px"
      :before-close="() => $refs.chooseMeetingDoc.cancel()"
      @close="closeChooseMeetingDoc()"
    >
      <ChooseMeetingDoc
        ref="chooseMeetingDoc"
        @close="closeChooseMeetingDoc"
        :expoMeetingCode="formData.expoMeetingCode"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="() => $refs.chooseMeetingDoc.cancel()">
          {{ this.$l('btn_cancel') }}
        </el-button>
        <el-button type="primary" size="small" @click="saveChooseMeetingDoc">
          {{ $l('btn_save') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ImportantLevelRadio from '../important-level-radio'
import TopicsEditor from '../topics-editor'
import TaskDoc from '../task-doc'
import ChooseMeetingDoc from '../choose-meeting-doc'
import dayjs from 'dayjs'
import { request } from '@/api/service'
export default {
  mixins: [EditLoading],
  components: { ImportantLevelRadio, TopicsEditor, TaskDoc, ChooseMeetingDoc },
  props: { parentTskCode: { type: String, default: '' } },
  data() {
    return {
      formData: {
        tskImportantLevel: 'Medium',
        tskEndDate: dayjs(new Date()).format('YYYY/MM/DD'),
        tskEndTime: dayjs(new Date()).format('HH:mm'),
        expoMeetingCode: '',
        expoInfoCode: '',
        tskTimeZone: '',
        tskType: 'T',
      },
      backDialogVisible: false,
      valueChangeFlag: false,
      rules: {
        tskOverview: [{ trigger: 'blur', required: true, message: ' ' }],
        tskType: [{ trigger: 'blur', required: true, message: ' ' }],
        tskBy: [{ trigger: 'change', required: true, message: ' ' }],
        custCode: [{ trigger: 'change', required: true, message: ' ' }],
        tskTimeZone: [
          { trigger: 'change', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              const { tskEndDate, tskEndTime } = this.formData
              if (!value || !tskEndDate || !tskEndTime) {
                return callback(new Error(' '))
              }
              callback()
            },
          },
        ],
        tskDescription: [{ trigger: 'blur', required: true, message: ' ' }],
      },
      localTimeZone: '',
      tskInfoCode: '',
      chooseMeetingVisible: false,
      tskTimeZoneOptions: [],
    }
  },
  computed: {
    taskLocalTime() {
      const { taskLocalTimeZone, tskLocalDate, tskLocalEndTime } = this.formData
      return [taskLocalTimeZone, tskLocalDate, tskLocalEndTime]
        .filter(Boolean)
        .join(' ')
    },
  },
  mounted() {
    this.getTskTimeZoneOptions()
  },
  methods: {
    valueChange() {
      this.valueChangeFlag = true
    },
    getTskTimeZoneOptions() {
      request({
        url: '/master/common/dict/biz',
        method: 'post',
        data: { dictType: 'meetingTimeZone' },
      }).then(async (res) => {
        this.tskTimeZoneOptions = res.body.data
        if (this.tskTimeZoneOptions && this.tskTimeZoneOptions.length > 0) {
          const localTimeZone = await this.loadLocalTimeZone()
          const localTimeZoneSet = new Set(
            this.tskTimeZoneOptions.map((item) => {
              return item.value
            })
          )
          if (localTimeZoneSet.has(localTimeZone)) {
            this.formData.tskTimeZone = localTimeZone
          }
        }
      })
    },
    async uploadTskFile() {
      if (!this.tskInfoCode || this.valueChangeFlag) {
        if (!(await this.save())) return
      }
      this.$refs.taskDoc.uploadFile()
    },
    async saveChooseMeetingDoc() {
      const checkData = await this.$refs.chooseMeetingDoc.getCheckData()
      if (!checkData || checkData.length == 0) {
        this.$message.warning('未选择会议文件')
        return
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoDocAddApi({
          tskInfoCode: this.tskInfoCode,
          expoMeetingDocCodes: checkData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.valueChangeFlag = false
      await this.$refs.taskDoc.getData()
      this.closeChooseMeetingDoc()
    },
    async getData(tskInfoCode) {
      this.tskInfoCode = tskInfoCode
      if (!this.tskInfoCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoTskInfoDetailApi({ localTimeZone, tskInfoCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const params = { ...this.formData, parentTskCode: this.parentTskCode }
      const res = await this.$api.expoTskInfoSaveApi(params).catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.backDialogVisible = false
      this.getData(body)
      this.$emit('reload')
      this.valueChangeFlag = false
      return true
    },
    cancel() {
      if (!this.valueChangeFlag) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
    closeChooseMeetingDoc() {
      this.chooseMeetingVisible = false
    },

    async chooseMeetingDoc() {
      if (!this.tskInfoCode || this.valueChangeFlag) {
        if (!(await this.save())) return
      }
      setTimeout(() => {
        this.chooseMeetingVisible = true
      }, 0)
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    custChange() {
      this.valueChangeFlag = true
      this.formData.expoMeetingCode = ''
    },
    async changeExpoMeeting() {
      this.valueChangeFlag = true
      const { expoMeetingCode } = this.formData
      if (expoMeetingCode) {
        const localTimeZone = await this.loadLocalTimeZone()
        const res = await this.$api
          .expoMeetingDetailApi({
            expoMeetingCode,
            localTimeZone,
          })
          .catch(() => null)
        if (!res) return
        this.formData.expoInfoCode = res.body.expoInfoCode
      }
    },
    changeExpoInfo() {
      this.valueChangeFlag = true
      this.formData.expoMeetingCode = ''
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .tag-ifno {
        .el-form-item__content {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
          .el-range-input {
            width: 34%;
          }
          .el-range-separator {
            width: 11%;
            color: #606266;
          }

          .el-date-editor .el-input__inner {
            text-align: center;
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
.button_info {
  background-color: #18c5bd;
  border: none;
}
.fws {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
